import { render, staticRenderFns } from "./FolderControlItemHeader.vue?vue&type=template&id=f408378e&scoped=true"
import script from "./FolderControlItemHeader.vue?vue&type=script&lang=js"
export * from "./FolderControlItemHeader.vue?vue&type=script&lang=js"
import style0 from "./FolderControlItemHeader.vue?vue&type=style&index=0&id=f408378e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f408378e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
